// extracted by mini-css-extract-plugin
export default {"form":"ChangeForm__form--SlL"};